<template>
  <div class="pDetail" v-loading="isLoading">
    <div class="pControl flex-row flex__between">
      <div class="pAddShape flex-row flex__left">
        <canvas-tool-button
          :label="'Xoá'"
          :iconClass="'fas fa-trash font-size__medium color__red '"
          @click="deleteShape"
          :disabled="!selectedShape || isEditable"
        >
        </canvas-tool-button>
        <canvas-font-size
          @fontSizeChanged="setFontSize"
          :disabled="!isFontSizeChangable || isEditable"
        ></canvas-font-size>
        <canvas-buttons-group
          :disabled="!isFontSizeChangable || isEditable"
          @alignChanged="setAlign"
          :buttonConfigs="alignmentButtonConfigs"
        ></canvas-buttons-group>
        <canvas-buttons-group
          :disabled="!isFontSizeChangable || isEditable"
          @alignChanged="setFontStyle"
          :buttonConfigs="fontStyleButtonConfigs"
        ></canvas-buttons-group>
        <div
          class="BtnEdit flex-row flex__left padding-top-5 padding-bottom-5 padding-left-10 padding-right-10 margin-right-10 border-radius__3 btnStyle"
        >
          <el-tooltip
            placement="top"
          >
            <div slot="content">Thay đổi phông trắng</div>
            <el-button
              size="mini"
              class="btn-none__border"
              :disabled="!selectedShape || isEditable"
              @click="toggleTextBackground"
            >
              <i class="fas fa-image"></i>
            </el-button>
          </el-tooltip>
        </div>

      </div>
    </div>

    <transition name="el-fade-in-linear">
      <VuePerfectScrollbar :class="['pScrollDoc transition-box page-center']">
        <div ref="canvasTemplate" style="position: relative">
          <div ref="canvasContainer"></div>
        </div>

      </VuePerfectScrollbar>
    </transition>

    <edit-phu-luc-dialog
      ref="editPhuLucDialog"
      :isOpen="isOpenEditPhuLucDialog"
      v-if="isEnableEditPhuLucDialog"
      @closed="isEnableEditPhuLucDialog = false"
      @closeDialog="isOpenEditPhuLucDialog = false"
    >
    </edit-phu-luc-dialog>
  </div>
</template>

<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import CanvasToolButton from "./canvas-tool-button";
  import Konva from "konva";
  import constants from "../../../constants";
  import uuidv4 from "uuid/v4";
  import h from "../../../services/h";
  import CanvasFontSize from "./canvas-font-size";
  import CanvasButtonsGroup from "./canvas-buttons-group";
  import EditPhuLucDialog from "./edit-phu-luc-dialog";
  import dateUtils from "../../../dateUtils";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import utils from "../../../services/utils";

  export default {
    name: "detail-docs-v2",
    props: ["isLoading", "docDate", "docCode"],

    components: {
      EditPhuLucDialog,
      CanvasButtonsGroup,
      CanvasFontSize,
      CanvasToolButton,
      VuePerfectScrollbar
    },

    computed: {
      isDrawing() {
        return !!this.action;
      },
      isFontSizeChangable() {
        return this.selectedShape && this.selectedShape.className === "Text";
      }
    },

    data() {
      return {
        stage: null,
        backgroundLayer: null,
        backgroundImage: null,
        drawLayer: null,
        backgroundURL: null,
        scale: 1,
        action: null,
        startPointerPosition: null,
        shapeOptions: null,
        drawingShape: null,
        transformer: null,
        selectedShape: null,
        textNodeBackgroundShapeRelations: [],
        shapeOptionsData: [],
        alignmentButtonConfigs: [
          {
            value: constants.DETAIL_DOCS_PAGE.ALIGN.LEFT,
            label: "Căn trái",
            iconClass: "fas fa-align-left"
          },
          {
            value: constants.DETAIL_DOCS_PAGE.ALIGN.CENTER,
            label: "Căn trái",
            iconClass: "fas fa-align-center"
          },
          {
            value: constants.DETAIL_DOCS_PAGE.ALIGN.RIGHT,
            label: "Căn trái",
            iconClass: "fas fa-align-right"
          },
          {
            value: constants.DETAIL_DOCS_PAGE.ALIGN.JUSTIFY,
            label: "Dàn đều",
            iconClass: "fas fa-align-justify"
          }
        ],
        fontStyleButtonConfigs: [
          {
            value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.NORMAL,
            label: "Bình thường",
            iconClass: "fas fa-ad"
          },
          {
            value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.BOLD,
            label: "Đậm",
            iconClass: "fas fa-bold"
          },
          {
            value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC,
            label: "Nghiêng",
            iconClass: "fas fa-italic"
          }
        ],
        isOpenEditPhuLucDialog: false,
        isEnableEditPhuLucDialog: false,

        autoTextImages: [],
        isAutoAddedTextImage: false,
        isEditable: false,
      };
    },

    watch: {
      isOpenEditPhuLucDialog(newValue) {
        newValue && (this.isEnableEditPhuLucDialog = newValue);
      }
    },

    mounted() {
      this.initCanvas();
    },

    methods: {
      isPageModified() {
        return !!(this.drawLayer.children && this.drawLayer.children.length);
      },

      toImagePromise(shape, config) {
        return new Promise((resolve, reject) => {
          config.callback = image => {
            resolve(image);
          };
          shape.toImage(config);
        });
      },

      merge2ImagesToBase64(image, textBackgroundImage) {
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        let backgroundWidth = (canvas.width = textBackgroundImage.width);
        let backgroundHeight = (canvas.height = textBackgroundImage.height);
        // context.globalAlpha = 0;
        context.drawImage(textBackgroundImage, 0, 0);
        context.globalAlpha = 1; //Remove if pngs have alpha
        let imageWidth = image.width;
        let imageHeight = image.height;
        context.drawImage(
          image,
          (backgroundWidth - imageWidth) / 2,
          (backgroundHeight - imageHeight) / 2
        );
        return canvas.toDataURL("image/png");
      },

      convertImageToBase64(image1) {
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        canvas.width = image1.width;
        canvas.height = image1.height;
        context.globalAlpha = 1.0;
        context.drawImage(image1, 0, 0);
        return canvas.toDataURL("image/png");
      },

      toBase64Promise(shape, config) {
        return this.toImagePromise(shape, config).then(image => {
          let className = shape.className;
          if (className !== "Text") return this.convertImageToBase64(image);
          let textBackgroundShape = this.findTextNodeBackgroundShape(shape.id());
          if (!textBackgroundShape) return this.convertImageToBase64(image);
          return this.toImagePromise(textBackgroundShape, config).then(
            textBackgroundImage =>
              this.merge2ImagesToBase64(image, textBackgroundImage)
          );
        });
      },

      getPageImageData() {
        let pixelRatio = 1 / this.scale;
        let pageSize = this.backgroundImage.size();

        //loai bo textNodeBackground;
        let shapes = h.findAll(this.drawLayer.getChildren(), shape => {
          let shapeOptions = this.findShapeOptionsByShapeId(shape.id());
          return shapeOptions && shapeOptions.shapeType;
        });

        return Promise.all(
          h.collect(shapes, shape => {
            let shapeOption = this.findShapeOptionsByShapeId(shape.id());
            let className = shape.className;
            let toImageConfig =
              className === "Image"
                ? {pixelRatio: 1}
                : {pixelRatio: pixelRatio};
            return this.toBase64Promise(shape, toImageConfig).then(base64 => {
              return {shape: shape, base64: base64, userDeptRoleView: shapeOption.userDeptRoleView};
            });
          })
        ).then(imageResults => {
          return {
            size: {
              width: pageSize.width,
              height: pageSize.height
            },
            pageImage: this.stage.toDataURL({pixelRatio: pixelRatio}),
            shapeImages: h.collect(imageResults, imageResult => {
              let shape = imageResult.shape;
              let base64 = imageResult.base64;
              let className = shape.className;
              let shapeSize = shape.size();
              if (className === "Image") {
                shapeSize = {
                  width: shapeSize.width * shape.scaleX(),
                  height: shapeSize.height * shape.scaleY()
                };
              }
              let shapeOptions = this.findShapeOptionsByShapeId(shape.id());
              let shapePosition = shape.position();
              if (shapeOptions.addWhiteBackground) {
                //neu add them background > co margin > can tinh toan lai size & postion
                shapePosition = {
                  x: shapePosition.x - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
                  y: shapePosition.y - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN
                };
                shapeSize = {
                  width:
                    shapeSize.width + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2,
                  height:
                    shapeSize.height + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2
                };
              }
              return {
                uri: base64,
                orig_base64: shapeOptions && shapeOptions.orig_base64 ? shapeOptions.orig_base64 : "",
                shapeId: shape.id(),
                position: {
                  x: shapePosition.x * pixelRatio,

                  y: shapePosition.y * pixelRatio
                },
                size: {
                  width: shapeSize.width * pixelRatio,
                  height: shapeSize.height * pixelRatio
                },
                shapeType: shapeOptions ? shapeOptions.shapeType : null,
                userDeptRoleView: imageResult.userDeptRoleView
              };
            }),
          };
        });
      },

      getPageImageDataV2() {
        let pixelRatio = 1 / this.scale;
        let pageSize = this.backgroundImage.size();

        //loai bo textNodeBackground;
        let shapes = h.findAll(this.drawLayer.getChildren(), shape => {
          let shapeOptions = this.findShapeOptionsByShapeId(shape.id());
          return shapeOptions && shapeOptions.shapeType;
        });

        return Promise.all(
          h.collect(shapes, shape => {
            let shapeOption = this.findShapeOptionsByShapeId(shape.id());
            let className = shape.className;
            let toImageConfig =
              className === "Image"
                ? {pixelRatio: 1}
                : {pixelRatio: pixelRatio};
            return this.toBase64Promise(shape, toImageConfig).then(base64 => {
              return {shape: shape, base64: base64, userDeptRoleView: shapeOption.userDeptRoleView};
            });
          })
        ).then(imageResults => {
          return {
            size: {
              width: pageSize.width * this.backgroundImage.scaleX(),
              height: pageSize.height * this.backgroundImage.scaleY(),
            },
            pageImage: this.stage.toDataURL({pixelRatio: pixelRatio}),
            shapeImages: h.collect(imageResults, imageResult => {
              let shape = imageResult.shape;
              let base64 = imageResult.base64;
              let className = shape.className;
              let shapeSize = shape.size();
              if (className === "Image") {
                shapeSize = {
                  width: shapeSize.width * shape.scaleX(),
                  height: shapeSize.height * shape.scaleY()
                };
              }
              let shapeOptions = this.findShapeOptionsByShapeId(shape.id());
              let shapePosition = shape.position();
              if (shapeOptions.addWhiteBackground) {
                //neu add them background > co margin > can tinh toan lai size & postion
                shapePosition = {
                  x: shapePosition.x - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
                  y: shapePosition.y - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN
                };
                shapeSize = {
                  width:
                    shapeSize.width + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2,
                  height:
                    shapeSize.height + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2
                };
              }
              return {
                uri: base64,
                shapeId: shape.id(),
                position: {
                  x: shapePosition.x,
                  y: shapePosition.y
                },
                size: {
                  width: shapeSize.width,
                  height: shapeSize.height
                },
                shapeType: shapeOptions ? shapeOptions.shapeType : null,
                userDeptRoleView: imageResult.userDeptRoleView
              };
            }),
          };
        });
      },

      getPageData() {
        return {
          stage: JSON.parse(this.stage.toJSON()),
          textNodeBackgroundShapeRelations: this.textNodeBackgroundShapeRelations,
          shapeOptionsData: this.shapeOptionsData
        };
      },

      deleteShape() {
        if (this.transformer) {
          this.transformer.destroy();
          this.transformer = null;
        }
        if (this.selectedShape) {
          this.removeShapeOptionsByShapeId(this.selectedShape.id());
          if (this.selectedShape.className === "Text")
            this.deleteTextNodeBackgroundShape(this.selectedShape.id());
          this.selectedShape.destroy();
          this.selectedShape = null;
        }
        this.drawLayer.draw();
      },

      findTextNodeBackgroundShape(textNodeId) {
        let textNodeBackgroundShapeRelation = h.find(
          this.textNodeBackgroundShapeRelations,
          item => item.textNodeId === textNodeId
        );
        if (!textNodeBackgroundShapeRelation) return null;
        let textNodeBackgroundShapeId =
          textNodeBackgroundShapeRelation.textBackgroundShapeId;
        return this.drawLayer.find("#" + textNodeBackgroundShapeId)[0];
      },

      deleteTextNodeBackgroundShape(textNodeId) {
        let textNodeBackgroundShapeRelation = h.find(
          this.textNodeBackgroundShapeRelations,
          item => item.textNodeId === textNodeId
        );
        if (textNodeBackgroundShapeRelation) {
          let textNodeBackgroundShapeId =
            textNodeBackgroundShapeRelation.textBackgroundShapeId;
          let textBackgroundShape = this.drawLayer.find(
            "#" + textNodeBackgroundShapeId
          )[0];
          if (textBackgroundShape) textBackgroundShape.destroy();
          this.textNodeBackgroundShapeRelations.splice(
            this.textNodeBackgroundShapeRelations.indexOf(
              textNodeBackgroundShapeRelation
            ),
            1
          );
        }
      },

      setFontSize(fontSize) {
        this.selectedShape.fontSize(fontSize);
        this.drawLayer.draw();
      },

      setAlign(align) {
        this.selectedShape.align(align);
        this.drawLayer.draw();
      },

      setFontStyle(fontStyle) {
        this.selectedShape.fontStyle(fontStyle);
        this.drawLayer.draw();
      },

      toggleTextBackground() {
        const textNode = this.selectedShape
        this.shapeOptions.addWhiteBackground = !this.shapeOptions.addWhiteBackground
        const existingRelation = this.textNodeBackgroundShapeRelations.find(
          relation => relation.textNodeId === textNode.id()
        );
        const backgroundShape = this.drawLayer.findOne(
          '#' + existingRelation.textBackgroundShapeId
        );
        if (backgroundShape) {
          backgroundShape.setAttrs({
            fill: this.shapeOptions.addWhiteBackground ? 'white' : '',
          });
          this.drawLayer.draw();
        }
      },

      initCanvas() {
        this.stage = new Konva.Stage({container: this.$refs.canvasContainer});
        this.stage.add(
          (this.backgroundLayer = new Konva.Layer({name: "backgroundLayer"}))
        );
        this.stage.add(
          (this.drawLayer = new Konva.Layer({
            name: constants.DETAIL_DOCS_PAGE.DRAW_LAYER_NAME
          }))
        );
        let konvaContent = this.$refs.canvasContainer.querySelector(
          ".konvajs-content"
        );
        konvaContent.style.position = "absolute";
        konvaContent.style.top = 0;
        konvaContent.style.left = 0;
        this.initAction();
      },

      initAction() {
        this.stage.on("mousedown", () => {
          if (this.isDrawing) this.startDrawing();
        });
        this.stage.on("mousemove", () => {
          if (this.isDrawing) this.dragDrawing();
        });
        this.stage.on("mouseup", () => {
          if (this.isDrawing) this.endDrawing();
        });
        this.stage.on("click", event => {
          /**
           * click outside;
           */
          if (event.target === this.backgroundImage) {
            this.removeTransformer_();
            this.drawLayer.draw();
          }
        });
      },

      setDraggableForAllShapes(draggable) {
        h.each(this.drawLayer.children, child => child.draggable(draggable));
        this.drawLayer.draw();
      },

      startDrawing() {
        this.setDraggableForAllShapes(false); // tranh truong hop chen anh moi tai vi tri thuoc anh cu > se bi nham lan;
        let pos = this.stage.getPointerPosition();
        let absolutePosition = this.stage.absolutePosition();
        let shape;
        this.startPointerPosition = [
          pos.x - absolutePosition.x,
          pos.y - absolutePosition.y
        ];
        let promise;
        switch (this.action) {
          case constants.DETAIL_DOCS_PAGE.ACTION.ADD_TEXT:
            shape = this.drawShapeText(this.shapeOptions);
            this.initForShapeText(shape, this.shapeOptions);
            this.initActionForShapeText(shape, this.shapeOptions);
            promise = Promise.resolve(shape);
            break;
          case constants.DETAIL_DOCS_PAGE.ACTION.ADD_IMAGE:
            promise = this.drawShapeImage(this.shapeOptions);
            break;
          case constants.DETAIL_DOCS_PAGE.ACTION.ADD_QR:
            promise = this.drawBase64Img(this.shapeOptions);
            break;
          default:
            break;
        }
        promise.then(shape => {
          this.shapeOptionsData.push({
            shapeId: shape.id(),
            shapeOptions: this.shapeOptions
          });
          this.drawingShape = shape;
          this.commonInitShape(shape);
          this.drawLayer.add(shape);
          this.selectShape(shape);
        });
      },

      dragDrawing() {
        let pos = this.stage.getPointerPosition();
        let absolutePosition = this.stage.absolutePosition();
        let pointerPosition = [
          pos.x - absolutePosition.x,
          pos.y - absolutePosition.y
        ];
        switch (this.action) {
          case constants.DETAIL_DOCS_PAGE.ACTION.ADD_IMAGE:
            if (this.drawingShape) {
              if (this.shapeOptions.fixedWidth) {
                let scale =
                  (this.shapeOptions.fixedWidth * this.scale) /
                  this.drawingShape.width();
                let x =
                  pointerPosition[0] - (this.drawingShape.width() * scale) / 2;
                let y =
                  pointerPosition[1] - (this.drawingShape.height() * scale) / 2;
                this.drawingShape.setAttrs({
                  x: x,
                  y: y,
                  scaleX: scale,
                  scaleY: scale
                });
              } else {
                let scale =
                  (pointerPosition[0] - this.startPointerPosition[0]) /
                  this.drawingShape.width();
                this.drawingShape.scale({x: scale, y: scale});
              }
            }
            break;
          default:
            break;
        }
        this.drawLayer.draw();
        this.stage.draw();
      },

      commonInitShape(shape) {
        shape.on("mousedown", event => {
          if (!this.isDrawing && shape === event.target) {
            this.selectShape(event.target);
          }
        });
      },

      initForShapeText(textNode, shapeOptions) {
        if (shapeOptions.addWhiteBackground) {
          //add white background
          let textNodePosition = textNode.absolutePosition();
          let textBackgroundShape = new Konva.Rect({
            id: uuidv4(),
            x: textNodePosition.x - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
            y: textNodePosition.y - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
            width: textNode.width() + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2,
            height:
              textNode.height() + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2,
            fill: "white"
          });
          this.drawLayer.add(textBackgroundShape);
          this.textNodeBackgroundShapeRelations.push({
            textNodeId: textNode.id(),
            textBackgroundShapeId: textBackgroundShape.id()
          });
        }
      },

      initActionForShapeText(textNode, options) {
        textNode.on("transform", () => {
          //resize text node;
          textNode.setAttrs({
            width: textNode.width() * textNode.scaleX(),
            scaleX: 1
          });
          //
          this.redrawTextNodeShapeBackgroundShape(textNode);
        });

        textNode.on("dragmove", event => {
          if (event.target === textNode) {
            this.redrawTextNodeShapeBackgroundShape(textNode);
          }
        });

        textNode.on("dblclick", event => {
          this.isEditable = true
          if (options.editable && event.target === textNode) {
            if(options.shapeType === constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC){
              let text = textNode.text();
              this.isOpenEditPhuLucDialog = true;
              this.$nextTick(() => {
                this.$refs.editPhuLucDialog.setValue(text);
                this.$refs.editPhuLucDialog.$on("valueChanged", event => {
                  this.isOpenEditPhuLucDialog = false;
                  textNode.text(event.value);
                  this.drawLayer.draw();
                });
              });
            }else {
              this.transformer.hide();
              textNode.hide();
              this.$nextTick(() => {
                this.editTextNode(textNode, this.transformer)
                this.drawLayer.draw();
              });
            }
          }
        });
      },

      editTextNode(textNode) {
        const canvasContainer = this.$refs.canvasTemplate;
        var textPosition = textNode.absolutePosition();
        var textarea = document.createElement('textarea');
        canvasContainer.appendChild(textarea);
        textarea.value = textNode.text();
        textarea.style.position = 'absolute';
        textarea.style.top = textPosition.y + 'px';
        textarea.style.left = textPosition.x + 'px';
        textarea.style.width = textNode.width() + 'px';
        textarea.style.height = textNode.height() + 'px';
        textarea.style.fontSize = textNode.fontSize() + 'px';
        textarea.style.border = '1px solid';
        textarea.style.zIndex = 99999;
        textarea.style.padding = '0px';
        textarea.style.margin = '0px';
        textarea.style.overflow = 'hidden';
        textarea.style.outline = 'none';
        textarea.style.resize = 'none';
        textarea.style.lineHeight = textNode.lineHeight();
        textarea.style.fontFamily = textNode.fontFamily();
        textarea.style.transformOrigin = 'left top';
        textarea.style.textAlign = textNode.align();
        textarea.style.color = textNode.fill();
        textarea.focus();

        this.stage.on("click", event => {
          if (event.target === this.backgroundImage) {
            if(canvasContainer && canvasContainer.contains(textarea) && textNode) {
              canvasContainer.removeChild(textarea);
              textNode.show();
              textNode.text(textarea.value);
              this.isEditable = false
              this.redrawTextNodeShapeBackgroundShape(textNode);
              this.removeTransformer_();
              this.drawLayer.draw();
              this.stage.draw();
            }
          }
        });

        function setTextareaWidth(newWidth) {
          if (!newWidth) {
            newWidth = textNode.placeholder.length * textNode.fontSize();
          }
          textarea.style.width = newWidth + 'px';
        }

        textarea.addEventListener('keydown', function (e) {
          let scale = textNode.getAbsoluteScale().x;
          setTextareaWidth(textNode.width() * scale);
          textarea.style.height = 'auto';
          textarea.style.height =
            textarea.scrollHeight + textNode.fontSize() + 'px';
        });
      },

      redrawTextNodeShapeBackgroundShape(textNode) {
        let textNodeId = textNode.id();
        let textNodeBackgroundShapeRelations = h.find(
          this.textNodeBackgroundShapeRelations,
          item => item.textNodeId === textNodeId
        );
        let textNodeBackgroundShapeId = textNodeBackgroundShapeRelations
          ? textNodeBackgroundShapeRelations.textBackgroundShapeId
          : null;
        if (textNodeBackgroundShapeId) {
          let textBackgroundShape = this.drawLayer.find(
            "#" + textNodeBackgroundShapeId
          )[0];
          if (textBackgroundShape) {
            let textNodePosition = textNode.absolutePosition();
            textBackgroundShape.absolutePosition({
              x: textNodePosition.x - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
              y: textNodePosition.y - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN
            });
            textBackgroundShape.width(
              textNode.width() + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2
            );
            textBackgroundShape.height(
              textNode.height() + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2
            );
          }
        }
      },

      selectShape(shape) {
        if (this.selectedShape === shape) return;
        if (this.selectedShape) this.removeTransformer_();
        this.selectedShape = shape;
        switch (shape.className) {
          case "Image":
            this.transformer = new Konva.Transformer({
              anchorStroke: "red",
              anchorFill: "red",
              anchorSize: 5,
              borderStroke: "red",
              borderDash: [5, 5],
              padding: 0,
              enabledAnchors: [
                "top-left",
                "top-right",
                "bottom-left",
                "bottom-right"
              ],
              rotateEnabled: false,
              boundBoxFunc: (oldBoundBox, newBoundBox) => {
                // if (Math.abs(newBoundBox.width) < 50) {
                //   return oldBoundBox;
                // }
                return newBoundBox;
              }
            });
            break;
          default:
            this.transformer = new Konva.Transformer({
              anchorStroke: "red",
              anchorFill: "red",
              anchorSize: 5,
              borderStroke: "red",
              borderDash: [5, 5],
              padding: 0,
              enabledAnchors: ["middle-right", "middle-left"],
              rotateEnabled: false,
              boundBoxFunc: (oldBoundBox, newBoundBox) => {
                if (Math.abs(newBoundBox.width) < 100) {
                  return oldBoundBox;
                }
                return newBoundBox;
              }
            });
            break;
        }

        this.transformer.attachTo(shape);
        this.drawLayer.add(this.transformer);
        this.drawLayer.draw();
      },

      endDrawing() {
        this.setDraggableForAllShapes(true);
        this.action = null;
        this.drawingShape = null;
      },

      drawShapeText(options) {
        let scale =
          constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_96_PPI /
          (constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_150_PPI * this.scale);
        return new Konva.Text({
          id: uuidv4(),
          text: options && options.text ? options.text : "",
          x: this.startPointerPosition[0],
          y: this.startPointerPosition[1],
          // width: Math.round(
          //   (options.defaultWidth ||
          //     constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.TEXT_WIDTH) / scale
          // ),
          fontSize: Math.round(
            (options.fontSize ||
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_SIZE) / scale
          ),
          fontStyle:
            options.fontStyle ||
            constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_STYLE,
          fontFamily:
            options.fontFamily ||
            constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_FAMILY,
          fill: options.fill,
          draggable: true,
          padding: constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.TEXT_PADDING
        });
      },

      drawShapeImage(options) {
        return new Promise(resolve => {
          Konva.Image.fromURL(options.url, image => {
            this.shapeOptions.orig_base64 = image.toDataURL({
              pixelRatio: 2,
              mimeType: "image/png"
            });
            if (options.fixedWidth) {
              let scale = (options.fixedWidth * this.scale) / image.width();
              let x = this.startPointerPosition[0] - (image.width() * scale) / 2;
              let y = this.startPointerPosition[1] - (image.height() * scale) / 2;
              image.setAttrs({
                id: uuidv4(),
                x: x,
                y: y,
                scaleX: scale,
                scaleY: scale,
                draggable: true
              });
            } else {
              let scale = options.defaultWidth
                ? (options.defaultWidth * this.scale) / image.width()
                : 1;
              image.setAttrs({
                id: uuidv4(),
                x: this.startPointerPosition[0],
                y: this.startPointerPosition[1],
                scaleX: scale,
                scaleY: scale,
                draggable: true
              });
            }
            resolve(image);
          });
        });
      },

      loadPage(options) {
        if (this.isDrawing) this.endDrawing();
        this.drawLayer.destroyChildren();
        this.backgroundLayer.destroyChildren();
        this.backgroundURL = options.backgroundURL;
        return this.loadBackground()
          .then(() => this.initState(options.pageData))
          .then(() => {
            this.stage.draw();
            this.autoAddTextImages()
          });
      },

      findShapeOptionsByShapeId(shapeId) {
        let shapeOptionsDataItem = h.find(
          this.shapeOptionsData,
          item => item.shapeId === shapeId
        );
        return shapeOptionsDataItem ? shapeOptionsDataItem.shapeOptions : null;
      },

      removeShapeOptionsByShapeId(shapeId) {
        let indexOf = h.indexOf(
          this.shapeOptionsData,
          item => item.shapeId === shapeId
        );
        if (indexOf !== -1) this.shapeOptionsData.splice(indexOf, 1);
      },

      initState(pageData) {
        if (pageData) {
          this.textNodeBackgroundShapeRelations =
            pageData.textNodeBackgroundShapeRelations || [];
          this.shapeOptionsData = pageData.shapeOptionsData || [];
          let stage = pageData.stage;
          if (stage && stage.children && stage.children.length) {
            let drawLayerState = h.find(
              stage.children,
              child =>
                child.attrs.name === constants.DETAIL_DOCS_PAGE.DRAW_LAYER_NAME
            );
            if (drawLayerState) {
              return Promise.all(
                h.collect(drawLayerState.children, shapeState => {
                  let shape;
                  let shapeOptions = this.findShapeOptionsByShapeId(
                    shapeState.attrs.id
                  );
                  let promise;
                  switch (shapeState.className) {
                    case "Text":
                      shape = new Konva.Text(shapeState.attrs);
                      this.initActionForShapeText(shape, shapeOptions);
                      this.commonInitShape(shape);
                      promise = Promise.resolve(shape);
                      break;
                    case "Image":
                      promise = this.drawShapeImage(shapeOptions).then(image => {
                        image.setAttrs(shapeState.attrs);
                        this.commonInitShape(image);
                        return image;
                      });
                      break;
                    case "Rect":
                      shape = new Konva.Rect(shapeState.attrs);
                      promise = Promise.resolve(shape);
                      break;
                  }
                  return promise;
                })
              ).then(shapes => {
                h.each(shapes, shape => this.drawLayer.add(shape));
                this.drawLayer.draw();
              });
            }
          }
        }
        return Promise.resolve();
      },

      loadBackground() {
        return new Promise(resolve => {
          Konva.Image.fromURL(this.backgroundURL, image => {
            // this.scale = this.$refs.canvasContainer.clientWidth / image.width();
            this.scale =
              constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_96_PPI / image.width();
            image.setAttrs({
              x: 0,
              y: 0,
              scaleX: this.scale,
              scaleY: this.scale
            });
            this.stage.width(image.width() * this.scale);
            this.stage.height(image.height() * this.scale);
            this.backgroundImage = image;
            this.backgroundLayer.add(image);
            this.backgroundLayer.draw();
            resolve();
          });
        });
      },

      addText(options) {
        if (this.isDrawing) this.endDrawing();
        this.action = constants.DETAIL_DOCS_PAGE.ACTION.ADD_TEXT;
        this.shapeOptions = {
          text: options.text,
          fill: options.fill,
          editable: options.editable,
          shapeType: options.shapeType,
          defaultWidth: options.defaultWidth,
          fontSize: options.fontSize,
          fontStyle: options.fontStyle,
          addWhiteBackground: options.addWhiteBackground
        };
        this.removeTransformer();
      },

      addImage(options) {
        if (this.isDrawing) this.endDrawing();
        this.action = constants.DETAIL_DOCS_PAGE.ACTION.ADD_IMAGE;
        this.shapeOptions = {
          url: options.url,
          fixedWidth: options.fixedWidth,
          fixedHeight: options.fixedHeight,
          shapeType: options.shapeType,
          defaultWidth: options.defaultWidth,
          userDeptRoleView: options.userDeptRoleView
        };
        this.removeTransformer();
      },

      addBase64(base64) {
        if (this.isDrawing) this.endDrawing();
        this.action = constants.DETAIL_DOCS_PAGE.ACTION.ADD_QR;
        this.shapeOptions = {
          base64,
          defaultWidth: 200,
          shapeType:  constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.QR
        };
        this.removeTransformer();
      },

      drawBase64Img(options) {
        return new Promise((resolve, reject) => {
          const imageObj = new Image();
          // Set up load event handler before setting src
          imageObj.onload = () => {
            const image = new Konva.Image({
              id: uuidv4(),
              image: imageObj,
              draggable: true
            });
            if (options.fixedWidth) {
              const scale = (options.fixedWidth * this.scale) / imageObj.width;
              const x = this.startPointerPosition[0] - (imageObj.width * scale) / 2;
              const y = this.startPointerPosition[1] - (imageObj.height * scale) / 2;
              image.setAttrs({
                x: x,
                y: y,
                scaleX: scale,
                scaleY: scale
              });
            } else {
              // Use default width or scale of 1
              const scale = options.defaultWidth
                ? (options.defaultWidth * this.scale) / imageObj.width
                : 1;
              image.setAttrs({
                x: this.startPointerPosition[0],
                y: this.startPointerPosition[1],
                scaleX: scale,
                scaleY: scale
              });
            }
            image.image(imageObj)
            resolve(image);
          };
          // imageObj.onerror = (error) => {
          //   reject(error);
          // };
          imageObj.src = options.base64;
        });
      },

      removeTransformer_() {
        if (this.transformer) {
          this.transformer.destroy();
          this.transformer = null;
          this.selectedShape = null;
          this.drawingShape = null;
        }
      },

      removeTransformer() {
        if (this.transformer) {
          this.removeTransformer_();
          this.stage.draw();
        }
      },

      initAutoTextImages() {
        if(this.docDate){
          let docDate_ = dateUtils.toMoment(this.docDate);
          this.autoTextImages.push({
            id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE,
            type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE,
            value: utils.convertDateTime(docDate_),
            fontConfig: {additionalWidth: 100}
          });
        }

        if(this.docCode) {
         this.autoTextImages.push({
           id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE,
           type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE,
           value: errorMessageFilter({
             errorCode: "signToken.docCode",
             params: [this.docCode]
           }),
           fontConfig: {
             fontStyle: "normal",
             additionalWidth: 50,
             minLength: 200
           }
         });
         }


      },

      startAutoDrawing() {
        this.setDraggableForAllShapes(false); // tranh truong hop chen anh moi tai vi tri thuoc anh cu > se bi nham lan;
        let shape;
        // this.startPointerPosition = [10, 10];
        switch (this.action) {
          case constants.DETAIL_DOCS_PAGE.ACTION.ADD_TEXT:
            shape = this.drawShapeText(this.shapeOptions);
            this.initForShapeText(shape, this.shapeOptions)
            this.initActionForShapeText(shape, this.shapeOptions);
            this.shapeOptionsData.push({
              shapeId: shape.id(),
              shapeOptions: this.shapeOptions
            });
            this.drawingShape = shape;
            this.commonInitShape(shape);
            this.drawLayer.add(shape);
            this.selectShape(shape);
            break;
          default:
            break;
        }
      },

      initShapeOptions(textImage) {
        let shapeType;
        let defaultWidth;
        let fontSize;
        let fontStyle;
        let fill;
        let addWhiteBackground = true;
        switch (textImage.type) {
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_CODE;
            defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.DOC_DATE_WIDTH;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_DATE;
            defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.DOC_DATE_WIDTH;
            fontSize = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_SIZE;
            fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC;
            break;
          default:
            shapeType = null;
        }

        this.action = constants.DETAIL_DOCS_PAGE.ACTION.ADD_TEXT;
        this.shapeOptions = {
          text: textImage.value,
          fill: fill,
          editable: true,
          shapeType: shapeType,
          defaultWidth: defaultWidth,
          fontSize: fontSize,
          fontStyle: fontStyle,
          addWhiteBackground: addWhiteBackground
        };

        this.startAutoDrawing()
      },

      autoAddTextImages() {
        if (!this.isAutoAddedTextImage) {
          this.initAutoTextImages();
          for (let i = 0; i < this.autoTextImages.length; i++) {
            let textImage = this.autoTextImages[i];
            if (textImage.type === constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE) {
              this.startPointerPosition = [Math.round(113 / this.scale), Math.round(98 / this.scale)];
            } else if (textImage.type === constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE) {
              this.startPointerPosition = [Math.round(328 / this.scale), Math.round(98 / this.scale)];
            }
            this.initShapeOptions(textImage)
          }
          this.endDrawing()
          this.isAutoAddedTextImage = true
        }
      }
    }
  };
</script>
<style scoped>
.btnStyle{
  border-color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/detail-docs-v2.vue